import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Get } from "utils/axios";
import { requestError } from "utils/requestHandler";
import { RootCategories } from "../assets";

const HOC = (WrappedComponent) => {
	class WithHOC extends Component {
		state = {
			loading: false,
			categories: RootCategories,
			flattenCategories: [],
		};

		onChangeSampleHOC = (key, val) => this.setState({ [key]: val });

		load = (param) => this.setState({ loading: param });

		handleGetCategoryPromise = (index) => {
			return new Promise((resolve, reject) => {
				Get(
					`/mywheels/find-children-categories/${index + 1}`,
					(payload) => {
						this.getCategoriesSuccess(payload, index + 1);
						resolve(payload.data);
					},
					(error) => {
						this.getCategoriesError(error);
						reject(error);
					},
					this.load
				);
			});
		};

		getCategories = () => {
			const apiPromises = [];
			for (let index = 0; index < 4; index++) {
				apiPromises.push(this.handleGetCategoryPromise(index));
			}

			Promise.all(apiPromises)
				.then((responses) => {
					const tempFlatten = responses.flat();
					let tempFiltered = _.filter(tempFlatten, (val) => val.parent_id);

					this.setState({
						flattenCategories: tempFiltered,
					});
				})
				.catch((error) => {
					console.error(error);
				});
		};
		getCategoriesSuccess = (payload, id) => {
			let tempPayload = _.cloneDeep(this.state.categories);
			let tempIndex = _.findIndex(this.state.categories, {
				id,
			});

			tempPayload[tempIndex]["children"] = _.filter(
				payload.data,
				(val) => val.parent_id
			);

			return this.setState({
				categories: tempPayload,
			});
		};
		getCategoriesError = (error) => requestError(error);

		render = () => {
			return (
				<WrappedComponent
					{...this.props}
					onLoadCategory={this.state.loading}
					getCategories={this.getCategories}
					categories={this.state.categories}
					flattenCategories={this.state.flattenCategories}
				/>
			);
		};
	}
	const mapStateToProps = (state) => ({ data: state });
	return connect(mapStateToProps)(WithHOC);
};

export default HOC;
